import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import FundCard from "../Components/FundCard";

export default function FundCardPortal({
  element,
  fundUUID,
  frequency,
  fundTitle,
  fundDescription,
  hideHonoree,
  honoree,
  hidePledge,
  isPledge,
  hideJointGift,
}) {
  return createPortal(
    <FundCard
      fundUUID={fundUUID}
      frequency={frequency}
      fundTitle={fundTitle}
      fundDescription={fundDescription}
      hideHonoree={hideHonoree}
      honoree={honoree}
      hidePledge={hidePledge}
      isPledge={isPledge}
      hideJointGift={hideJointGift}
    />,
    element
  );
}
